export const faqs = [
  {
    q: "511爆料匿名投稿真的能匿名吗？",
    a: "可以。投稿时你可以不填写任何身份信息，后台只会看到线索内容本身。我们在整理与发布时统一使用“匿名・线索来源”的代号，不会公开投稿人的账号、手机号或私信记录。私信投稿同样默认脱敏。",
  },
  {
    q: "我要爆料，但不知道怎么写才容易被采纳？",
    a: "把时间、地点、人物、事件四要素尽量写清楚，能附截图或时间线更好。后台审核最看重的是可核对的信息点，而不是情绪化的表达。哪怕只有一句话，只要信息准确，也可能进入发酵环节。",
  },
  {
    q: "私信投稿和投稿表单有什么区别？",
    a: "私信投稿适合短小的现场见闻，随手发送即可；投稿表单适合信息量较大的内容，可以分项填写标题、类型与细节，也方便后续追加材料。两种方式最终都会进入同一个审核队列。",
  },
  {
    q: "投喂瓜料后多久会有回应？",
    a: "平均审核时长约三十八分钟，高峰期可能顺延。如果线索被采纳，页面状态会变更为“发酵中”；如果需要补充材料，我们会通过你留下的联系方式（如有）进行沟通，不会公开你的身份。",
  },
  {
    q: "为什么有的爆料显示“待补充”？",
    a: "“待补充”意味着线索的核心事实尚缺少独立信源交叉验证。我们不会因为信息不完整就丢弃它，而是保留展示并持续等待补充，避免过早下结论伤害到任何一方。",
  },
  {
    q: "511爆料会收钱删帖吗？",
    a: "不会。我们只依据证据决定线索的展示状态，不以任何形式接受删帖付费。若有人以511爆料名义联系你索要费用，请立刻通过官方邮箱告知我们。",
  },
  {
    q: "投稿人需要承担法律责任吗？",
    a: "我们鼓励基于事实的分享。请勿编造或传播未经核实的指控，涉及他人名誉与隐私的内容，平台会进行必要处理。投稿人对自己的线索真实性负责，平台仅作为信息汇集与核实协作方。",
  },
  {
    q: "可以帮我把以前的稿件撤回吗？",
    a: "可以。只要你能提供投稿时的线索编号或联系方式，我们会协助撤回或修正。撤回后相关内容不会再出现在广场列表中，但已被第三方转载的部分我们无法控制。",
  },
];